import { Component, Inject, Renderer2, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: 'wk-confirm-dialog.html',
  styleUrls: ['./wk-confirm-dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkConfirmDialogComponent {
  title: string;
  yesLabel: string;
  noLabel: string;
  message: string;
  yesButtonClass: string;
  showContent: boolean;
  unlistener: () => void;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<WkConfirmDialogComponent>,
    private readonly renderer: Renderer2
  ) {
    dialogRef.afterOpened().subscribe(() => {
      this.showContent = true;
    });
  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.yesLabel = this.data.yesLabel;
    this.noLabel = this.data.noLabel;
    this.message = this.data.message;
    this.yesButtonClass =
      this.data.yesButtonClass || 'wk-button wk-button-small';
    this.unlistener = this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute('hasOverlayClickClose')) {
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  stayProcess(): void {
    this.dialogRef.close(true);
  }

  ngOnDestroy() {
    this.unlistener();
  }
}
